/**
 * Field name conversion utilities.
 *
 * Converts between Aras property names (snake_case) and API field names (camelCase).
 * The system is fully dynamic - no hardcoded item type mappings needed.
 */

/**
 * Convert snake_case to camelCase.
 * Used to map Aras property names (snake_case) to API response field names (camelCase).
 *
 * Examples:
 *   "item_number" -> "itemNumber"
 *   "address_type" -> "addressType"
 *   "created_on" -> "createdOn"
 *   "lead_source" -> "leadSource"
 *
 * @param snakeCase - The snake_case string
 * @returns The camelCase string
 */
export const snakeToCamel = (snakeCase: string): string => {
  return snakeCase.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

/**
 * Convert camelCase to snake_case.
 * Used to map API field names (camelCase) to Aras property names (snake_case).
 *
 * Examples:
 *   "itemNumber" -> "item_number"
 *   "addressType" -> "address_type"
 *   "createdOn" -> "created_on"
 *   "leadSource" -> "lead_source"
 *
 * @param camelCase - The camelCase string
 * @returns The snake_case string
 */
export const camelToSnake = (camelCase: string): string => {
  return camelCase.replace(/([A-Z])/g, "_$1").toLowerCase();
};
